import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { AttendanceDashboardRoutingModule } from './attendance-dashboard-routing.module';
import { UserWorkAttendanceDashboardComponent } from './user-work-attendance-dashboard/user-work-attendance-dashboard.component';
import { UserWorkAttendanceDashboardSubheaderComponent } from './user-work-attendance-dashboard/user-work-attendance-dashboard-subheader/user-work-attendance-dashboard-subheader.component';
import { SalesPersonAttendanceDashboardComponent } from './sales-person-attendance-dashboard/sales-person-attendance-dashboard.component';
import { SalesPersonAttendanceDashboardSubheaderComponent } from './sales-person-attendance-dashboard/sales-person-attendance-dashboard-subheader/sales-person-attendance-dashboard-subheader.component';
import { AttendanceChartLegendComponent } from './shared/attendance-chart-legend/attendance-chart-legend.component';

@NgModule({
  declarations: [
    UserWorkAttendanceDashboardComponent,
    UserWorkAttendanceDashboardSubheaderComponent,
    SalesPersonAttendanceDashboardComponent,
    SalesPersonAttendanceDashboardSubheaderComponent,
    AttendanceChartLegendComponent,
  ],
  imports: [CommonModule, SharedModule, AttendanceDashboardRoutingModule],
})
export class AttendanceDashboardModule {}
